import { PageHero } from "../components/PageHero";
import { Contact } from "../components/Contact";
import { Accommodation } from "../components/Accommodation";

export default function ContactPage() {
  return (
    <>
      <PageHero media="/videos/contact-hero.mp4" overline="Contact" title="Come and" highlight="fly with us." subtitle="Visit us at Hangar 15, Rand Airport, or send a message — our admissions team will guide your first step into aviation." />
      <Contact />
      <Accommodation />
    </>
  );
}
